import { ProjectInterface } from './project.model';
import { CreateTaskValidation } from './task.model';
import { UserInterface } from './user.model';
export enum ManualLogStatus {
    Pending = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected',
}

export interface ManualLogInterface {
    _id: string;
    uid: string;
    startTime: string;
    endTime: string;
    note: string;
    taskId: string;
    trackingTimeId: string;
    totalTime: number;
    projectId: string;
    status: ManualLogStatus;
}

export interface GetManualLogHistoryResponse {
    data: {
        manualLog: ManualLogInterface;
        task: CreateTaskValidation;
        project: ProjectInterface;
        user: UserInterface;
    }[];
    total: number;
    page: number;
    limit: number;
}

export interface GetManualLogHistoryPayLoad {
    startDate?: string;
    endDate?: string;
    page?: number;
    limit?: number;
    uid?: string;
    status?: ManualLogStatus | 'all';
}
